// export const snapId = 'local:http://localhost:8080'
export const snapId = 'npm:dmail-snap'

export const installSnap = async (provider, version = '') => {
  const snaps = await provider.request({
    method: 'wallet_requestSnaps',
    params: {
      [snapId]: version ? { version } : {},
    },
  })

  return snaps?.[snapId] ?? null
};

export const invokeSnap = async (provider, { method, params }) => {
  return await provider.request({
    method: 'wallet_invokeSnap',
    params: {
      snapId,
      request: params ? { method, params } : { method },
    },
  });
}



async function hasSnapsSupport(provider = window.ethereum) {
  try {
    await provider.request({
      method: 'wallet_getSnaps',
    });

    return true;
  } catch {
    return false;
  }
}

export async function getSnapsProvider() {
  if (typeof window === 'undefined') {
    return null;
  }

  if (await hasSnapsSupport()) {
    return window.ethereum;
  }

  if (window.ethereum?.detected) {
    for (const provider of window.ethereum.detected) {
      if (await hasSnapsSupport(provider)) {
        return provider;
      }
    }
  }

  if (window.ethereum?.providers) {
    for (const provider of window.ethereum.providers) {
      if (await hasSnapsSupport(provider)) {
        return provider;
      }
    }
  }

  // const eip6963Provider = await getMetaMaskEIP6963Provider();

  // if (eip6963Provider && (await hasSnapsSupport(eip6963Provider))) {
  //   return eip6963Provider;
  // }

  return null;
}